import { Controller } from "@hotwired/stimulus"

// Main editor controller for Scripted Video Studio
// Handles tab keyboard shortcuts and global editor state
export default class extends Controller {
  connect() {
    this.bindKeyboardNavigation()
  }

  disconnect() {
    this.unbindKeyboardNavigation()
  }

  bindKeyboardNavigation() {
    this.keydownHandler = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.keydownHandler)
  }

  unbindKeyboardNavigation() {
    if (this.keydownHandler) {
      document.removeEventListener("keydown", this.keydownHandler)
    }
  }

  handleKeydown(event) {
    if (event.target.matches("input, textarea, select")) return

    // Alt+1-5 to switch tabs
    if (event.altKey && event.key >= "1" && event.key <= "5") {
      event.preventDefault()
      const tabs = ["script", "references", "scenes", "audio", "assembly"]
      const tabIndex = parseInt(event.key) - 1
      if (tabs[tabIndex]) {
        const tabLink = this.element.querySelector(`[href*="tab=${tabs[tabIndex]}"]`)
        if (tabLink) tabLink.click()
      }
    }
  }
}
